import useGetSettingsVerificationListItem from './useGetSettingsVerificationListItem'
export default useGetSettingsVerificationListItem
